var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-drawer',{attrs:{"width":1360,"visible":_vm.visible,"mask-closable":true,"ok-button-props":{ props: { loading: _vm.loading } },"body-style":{ paddingBottom: '80px' }},on:{"close":_vm.close,"ok":_vm.onSubmit}},[_c('template',{slot:"title"},[_c('span',[_vm._v(" 业务需求详情 ")])]),_c('Detail',{ref:"detailRef"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }